// extracted by mini-css-extract-plugin
module.exports = {"container":"free-answer_container__IDnMt","text":"free-answer_text__1IZmY","actions":"free-answer_actions__3sw7V"};